import {
  _deleteArgosV25,
  _getArgosV25,
  _postArgosV25,
  _putArgosV25,
} from './_internal';

export const createFunction = (payload: { functionData: any }) => {
  const route = `api/functions`;
  return _postArgosV25({ route: route, payload: payload.functionData });
};

export const updateFunction = (payload: {
  functionId: number;
  functionData: any;
}) => {
  const route = `api/functions/${payload.functionId}`;
  return _putArgosV25({ route: route, payload: payload.functionData });
};

export const deleteFunction = (payload: { functionId: number }) => {
  const route = `api/functions/${payload.functionId}`;
  return _deleteArgosV25({ route: route });
};

export const createTask = (payload: { taskData: any }) => {
  const route = `api/task`;
  return _postArgosV25({ route: route, payload: payload.taskData });
};

export const updateTask = (payload: { taskId: number; taskData: any }) => {
  const route = `api/task/${payload.taskId}`;
  return _putArgosV25({ route: route, payload: payload.taskData });
};

export const deleteTask = (payload: { taskId: number }) => {
  const route = `api/task/${payload.taskId}`;
  return _deleteArgosV25({ route: route });
};

export const executeTask = (payload: { taskId: number }) => {
  const route = `api/task/schedule/${payload.taskId}`;
  const res = _putArgosV25({ route: route });
  return res;
};

export const getVEnvs = () => {
  const route = `api/venvs`;
  return _getArgosV25({ route: route });
};

export const setVEnvToFunction = (payload: { venvId: number }) => {
  const route = `/api/functions/${payload.venvId}/venv`;
  return _putArgosV25({ route: route });
};

export const createVEnv = (payload: { venvData: any }) => {
  const route = `api/venvs`;
  return _postArgosV25({ route: route, payload: payload.venvData });
};

export const deleteVEnv = (payload: { venvId: number }) => {
  const route = `api/venvs/${payload.venvId}`;
  return _deleteArgosV25({ route: route });
};
